import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  CodigoOperacionControllerService,
  CodigoOperacionFilterDTO,
  OperacionGestionControllerService,
  PoseedorControllerService,
  PoseedorDTO,
  ResiduoEnvaseControllerService,
  ResiduoEnvaseFilterDTO,
  ResiduoEnvasePayloadDTO,
} from 'api-rest';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import Swal from 'sweetalert2';
import { ValidateService } from '../../../services/validate.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { Router } from '@angular/router';
import { Subscription, catchError, forkJoin, map, of, zip } from 'rxjs';
import { HoldersWasteForecastDuplicateDialogComponent } from '../holders-waste-forecast-duplicate-dialog/holders-waste-forecast-duplicate-dialog.component';
import { MatDialog } from '@angular/material/dialog';
//import { ResiduoEnvaseControllerService, ResiduoEnvasePayloadDTO } from 'dist/api-rest/api-poseedores';

@Component({
  selector: 'lib-holders-waste-forecast',
  templateUrl: './holders-waste-forecast.component.html',
  styleUrls: ['./holders-waste-forecast.component.scss'],
})
export class HoldersWasteForecastComponent implements OnChanges, OnInit {
  @Input() poseedorInfo!: PoseedorDTO | any;
  @Output() public refrescarPoseedorEvent = new EventEmitter<any>();

  formGroup!: FormGroup;
  tiposCodigosLer: any[] = [];
  operacionesGestion: any[] = [];
  suministraInfoList = [
    { id: 'Gestor', name: 'Gestor' },
    { id: 'Poseedor', name: 'Poseedor' },
  ];
  anios: any[] = [];
  codigosLerEndpoint =
    this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?poseedores=true';
  updateList: boolean = false;
  updateListOpera: boolean = false;
  flagDisabledForm: boolean = false;
  anioActual!: number;
  nimaAsignadoEnvalora: string = '9999999999';
  grid: any[] = [];

  pageNumber: number = 0;
  pageSize: number = 100;
  recordsTotal: number = 0;
  gestionArray: any[] = [];
  savingData: boolean = false;
  searchSubscription?: Subscription;
  headArray: any[] = [
    {
      Head: 'Año',
      FieldName: 'anioDatos',
    },
    {
      Head: 'Código LER y descripción de ENVALORA',
      FieldName: 'descripcionMCodLer',
      Tooltip: true,
    },
    {
      Head: 'Operación gestión específica',
      FieldName: 'operacionMGestion',
      Tooltip: true,
    },
    {
      Head: '',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'warning',
          icon: 'warning',
          toolTip:
            'NIMA de gestor no existe en la base de datos de gestores de ENVALORA',
          show: (row: any) => this.showWarning(row),
        },
      ],
    },
    {
      Head: 'NIMA del gestor',
      FieldName: 'nimaGestor',
    },
    {
      Head: 'Previsión cantidad anual generada (Kg)',
      FieldName: 'previsionCantidadGenerada',
    },
    {
      Head: '¿Quién suministra información de gestión?',
      FieldName: 'suministradorInformacion',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: (row: any) => row.canAccessDelete,
        },
        {
          nameButton: 'edit',
          icon: 'edit',
          toolTip: 'Editar',
          show: (row: any) => row.canAccessEdit,
        },
        {
          nameButton: 'duplicate',
          icon: 'file_copy',
          toolTip: 'Duplicar',
          show: (row: any) => row.canAccessDuplicate,
        },
      ],
      width: '2',
      permanent: true,
    },
  ];
  constructor(
    private formBuilder: FormBuilder,
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private poseedorControllerSrv: PoseedorControllerService,
    private validateSrv: ValidateService,
    private router: Router,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    private residuoEnvaseControllerSrv: ResiduoEnvaseControllerService,
    private codigoOperacionControllerService: CodigoOperacionControllerService,
    private operacionGestionControllerService: OperacionGestionControllerService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.formGroup = this.formBuilder.group({
      anio: [
        { value: null, disabled: false }
      ],
      codigoLer: [
        { value: null, disabled: false },
      ],
      operacionGestion: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      previsionAnual: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.pattern(this.validateSrv.twoDecimals),
          ]),
        },
      ],
      nima: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10)
          ]),
        },
      ],
      suministraInfo: [
        { value: null, disabled: false },
      ],
    });
  }
  ngOnInit(): void {
    this.valueChangeCodigoLer();
    this.anioActual = new Date().getFullYear();
    const limiteInferior = 2025;
    for (let i = this.anioActual - 3; i <= this.anioActual + 1; i++) {
      if (i >= limiteInferior) {
        this.anios.push({ id: i });
      }
    }
    this.formGroup
      .get('anio')
      ?.setValue(this.anioActual === 2024 ? 2025 : this.anioActual);
    this.buscarPrevision();
  }

  valueChangeCodigoLer() {
    this.formGroup.get('codigoLer')?.valueChanges.subscribe((value: any) => {
      if (value) {
        this.buscarOperacionesGestion();
      } else {
        this.gestionArray = [];
      }
    });
  }

  buscarOperacionesGestion() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.codigoOperacionControllerService
      .findAll12(backendFilter, { page: page, size: size })
      .subscribe({
        next: (res) => {
          this.spinnerSrv.loadingHide();
          if (res) {
            this.gestionArray = res?.datos ?? [];
          }
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  private getBackendFilter() {
    const backendFilter: CodigoOperacionFilterDTO = {
      codigoLer: [this.formGroup.get('codigoLer')?.value?.id],
      poseedores: true
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    return { backendFilter, page, size: this.pageSize };
  }
  private getBackendFilterBuscador() {
    const backendFilter: ResiduoEnvaseFilterDTO = {
      codigoLer: this.formGroup.get('codigoLer')?.value,
      poseedor: this.poseedorInfo.id ? { id: this.poseedorInfo.id } : undefined,
      anioDatos: this.formGroup.get('anio')?.value,
      operacionGestion: this.formGroup.get('operacionGestion')?.value,
      suministradorInformacion: this.formGroup.get('suministraInfo')?.value,
      nimaGestor: this.formGroup.get('nima')?.value,
      previsionCantidadGenerada: this.formGroup.get('previsionAnual')?.value,
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    return { backendFilter, page, size: this.pageSize };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['poseedorInfo'] && this.poseedorInfo) {
      const isReadOnly = [5, 8].includes(this.poseedorInfo?.estado?.id ?? -1);
      this.flagDisabledForm = isReadOnly;
      if (isReadOnly) {
        this.formGroup.disable();
      } else {
        this.formGroup.enable();
      }
      // Solo buscar si NO es el cambio provocado por refrescarPoseedorEvent
      if (!changes['poseedorInfo'].isFirstChange() && !this.savingData) {
        this.buscarPrevision();
      }
    }
  }
  getLerDescription(ler: any) {
    if (!ler || (!ler.tipoCodigo && !ler.descripcion && !ler.id)) return '';
    return (ler.tipoCodigo ?? '') + ' - ' + (ler.descripcion ?? '');
  }

  getOperacionDescription(op: any) {
    return op?.descripcion || '';
  }
  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'codigoLer': {
        return this.formGroup.get('codigoLer') as FormControl;
        break;
      }
      case 'operacionGestion': {
        return this.formGroup.get('operacionGestion') as FormControl;
        break;
      }
      default: {
        return this.formGroup.get('') as FormControl;
        break;
      }
    }
  }
  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm
    };
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }
  selPaginatorHasError(controlName: string) {
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }
  addPrevision(): void {
    if (!this.canAccessCreate()) {
      return;
    }

    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Revisar los errores en los campos ',
        'error'
      );
      return;
    }
    if (!this.savingData) {
      this.savingData = true;
      if (!this.validarDatosNimaPrefijado()) {
        this.savingData = false;
        return;
      }
      const existe = this.grid.find(
        (x) =>
          x.anioDatos === this.formGroup.get('anio')?.value &&
          x.codigoLer?.id === this.formGroup.get('codigoLer')?.value?.id &&
          x.operacionGestion?.id ===
          this.formGroup.get('operacionGestion')?.value?.id &&
          x.nimaGestor === this.formGroup.get('nima')?.value &&
          x.previsionCantidadGenerada ==
          this.formGroup.get('previsionAnual')?.value &&
          x.suministradorInformacion ===
          this.formGroup.get('suministraInfo')?.value
      );
      if (existe) {
        this.snackBarSrv.showSnackBar(
          'Ya existe la previsión de residuos de envases introducida',
          'error'
        );
        this.savingData = false;
      } else {
        //if(!this.savingData){
        this.savingData = true;
        let previsionAnual;
        if (this.formGroup.get('previsionAnual')?.value) {
          previsionAnual = Number.parseFloat(
            this.formGroup.get('previsionAnual')?.value
          );
        }
        let obj: ResiduoEnvasePayloadDTO = {
          anioDatos: this.formGroup.get('anio')?.value,
          codigoLer: this.formGroup.get('codigoLer')?.value,
          operacionGestion: this.formGroup.get('operacionGestion')?.value,
          nimaGestor: this.formGroup.get('nima')?.value,
          previsionCantidadGenerada: previsionAnual,
          suministradorInformacion: this.formGroup.get('suministraInfo')?.value,
          poseedor: this.poseedorInfo,
        };

        if (obj.previsionCantidadGenerada && obj.previsionCantidadGenerada > 1000) {
          Swal.fire({
            text: 'Por favor, verifique que el valor introducido en la previsión de la cantidad anual generada es correcto y está en las unidades correspondientes (Kg).',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Guardar',
            denyButtonText: 'Cancelar',
            allowOutsideClick: false,
          }).then((result: any) => {
            if (result.isConfirmed) {
              this.guardarPrevision(obj);
            } else {
              this.savingData = false;
            }
          });
        } else {
          this.guardarPrevision(obj);
        }
        //}
        
        
      }
    }
    
  }
  guardarPrevision(residuo: ResiduoEnvasePayloadDTO | any): void {
    this.spinnerSrv.loadingShow();
    this.residuoEnvaseControllerSrv.create3(residuo).subscribe({
      next: (response: PoseedorDTO) => {
        this.spinnerSrv.loadingHide();
        this.residuoEnvaseControllerSrv
          .comprobarNimaGestor(response.id!)
          .subscribe({
            next: (resultado: any) => {
              residuo.existeNima = resultado;
              if (resultado === false) {
                let mensaje = 'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.';
                this.snackBarSrv.showSnackBar(
                  mensaje,
                  'warning'
                );
              }
              this.refrescarPoseedorEvent.emit(true);
              this.savingData = false;
              //Reiniciar formulario 
              this.formGroup.patchValue({
                codigoLer: null,
                operacionGestion: null,
                nima: null,
                previsionAnual: null,
                suministraInfo: null,
              });
              this.formGroup.markAsPristine();
              this.formGroup.markAsUntouched();
            },
            error: (error: any) => { },
          });
      },
      error: (err) => {
        this.savingData = false;
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al guardar la previsión de residuos',
          'error'
        );
      },
    });
  }

  action(event: any) {
    if (!this.canAccessDelete()) {
      return;
    }

    if (event.nameButton == 'delete') {
      this.confirmacionEliminarPrevision(event);
    } else if (event.nameButton == 'duplicate') {
      this.duplicatePrevision(event);
    } else if (event.nameButton == 'edit') {
      this.editPrevision(event);
    }
      
  }
  confirmacionEliminarPrevision(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la previsión de residuos?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.spinnerSrv.loadingShow();
        this.residuoEnvaseControllerSrv.deleteById3(element.id).subscribe({
          next: (response: PoseedorDTO) => {
            this.spinnerSrv.loadingHide();
            this.refrescarPoseedorEvent.emit(true);
            this.snackBarSrv.showSnackBar(
              `Se ha eliminando correctamente.`,
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al eliminar la previsión de residuos',
              'error'
            );
          },
        });
      }
    });
  }

  anioSelected(): void {
    if (
      this.poseedorInfo?.residuosEnvase &&
      this.poseedorInfo?.residuosEnvase?.length > 0
    ) {
      let observables: any[] = [];

      let residuosFiltrados = this.poseedorInfo?.residuosEnvase.filter(
        (x: any) => x.anioDatos == this.formGroup.get('anio')?.value
      );
      if (residuosFiltrados?.length > 0) {
        residuosFiltrados.forEach((residuo: any) => {
          let observable = this.residuoEnvaseControllerSrv
            .comprobarNimaGestor(residuo.id)
            .pipe(
              map((resultado: any) => {
                residuo.existeNima = resultado;
                return residuo;
              }),
              catchError((error: any) => {
                console.error(
                  `Error comprobando Nima para residuo con id ${residuo.id}:`,
                  error
                );
                residuo.existeNima = false;
                return of(residuo);
              })
            );
          observables.push(observable);
        });

        zip(...observables).subscribe((residuosActualizados: any[]) => {
          this.grid = this.canAccessAll(residuosActualizados);
          setTimeout(() => {
            this.cdr.detectChanges();
          });
        });
      } else {
        this.grid = [];
        setTimeout(() => {
          this.cdr.detectChanges();
        });
      }
    } else {
      this.grid = [];
      setTimeout(() => {
        this.cdr.detectChanges();
      });
    }
  }

  showWarning(row: any) {
    return !row.existeNima;
  }

  canAccessDelete(): boolean {
    return (
      this.authService.can('poseedores-prevision', 'delete') &&
      this.poseedorInfo?.estado?.id !== 5 &&
      this.poseedorInfo?.estado?.id !== 8
    );
  }
  canAccessCreate(): boolean {
    return (
      this.authService.can('poseedores-prevision', 'create') &&
      this.poseedorInfo?.estado?.id !== 5 &&
      this.poseedorInfo?.estado?.id !== 8
    );
  }

  
  canAccessAll(list: any) {
    const resultDelete = this.canAccessDelete();
    const anioActual = new Date().getFullYear();

    const listPermission = list.map((objeto: any) => {
      let descripcionMCodLer =
        objeto.codigoLer.tipoCodigo + ' ' + objeto.codigoLer.descripcion;
      let operacionMGestion = (objeto.operacionGestion ? objeto.operacionGestion?.codigo +
        ' ' +
        objeto.operacionGestion?.descripcion : '')
      
      const isPastYear = objeto.anioDatos < anioActual;

      return {
        ...objeto,
        operacionMGestion: operacionMGestion,
        descripcionMCodLer: descripcionMCodLer,
        canAccessDelete: resultDelete,
        canAccessEdit: resultDelete && !isPastYear,
        canAccessDuplicate: resultDelete,
      };
    });

    return listPermission;
  }

  finalizar() {
    if (this.grid?.length > 0) {
      this.spinnerSrv.loadingShow();
      this.poseedorControllerSrv
        .finalizarDetalle(this.poseedorInfo.id!)
        .subscribe({
          next: (response: PoseedorDTO) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Proceso finalizado correctamente. Los datos serán revisados por Envalora y, en los próximos días, recibirá un correo electrónico con instrucciones para la firma del acuerdo.',
              'success'
            );
            this.router.navigate(['/initial-page']);
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al finalizar.',
              'error'
            );
          },
        });
    } else {
      this.snackBarSrv.showSnackBar(
        'Es necesario informar de, al menos, una previsión de residuos de envases para el año en curso',
        'error'
      );
    }
  }

  validarDatosNimaPrefijado() {
    if (this.poseedorInfo.nima === this.nimaAsignadoEnvalora) {
      //No puede registrar previsiones con códigos LER 15 01 10 o 15 01 11.
      if (this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 10' || this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 10*'
        || this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 11' || this.formGroup.get('codigoLer')?.value.tipoCodigo == '15 01 11*') {
        this.snackBarSrv.showSnackBar(
          `Si el NIMA del poseedor es ${this.nimaAsignadoEnvalora} no puede registrar previsiones con códigos LER  15 01 10 o 15 01 11.`,
          'error'
        );
        return false;
      }
      //No puede superar previsiones anuales de 1.000 t/año.
      let previsionAnual = 0;
      if (this.formGroup.get('previsionAnual')?.value) {
        previsionAnual = Number.parseFloat(this.formGroup.get('previsionAnual')?.value);
      }
      //Sumar el resto de previsiones existentes para el año seleccionado
      let residuosFiltrados = this.poseedorInfo?.residuosEnvase.filter(
        (x: any) => x.anioDatos == this.formGroup.get('anio')?.value
      );
      if (residuosFiltrados?.length > 0) {
        residuosFiltrados.forEach((residuo: any) => {
          previsionAnual += residuo.previsionCantidadGenerada;
        });
      }

      if (previsionAnual > 1000000) {
        this.snackBarSrv.showSnackBar(
          `Si el NIMA del poseedor es ${this.nimaAsignadoEnvalora} no puede superar previsiones anuales de 1.000 t/año.`,
          'error'
        );
        return false;
      }

    }

    return true;
  }

  onInput(controlName: string, event: any) {
    const control = this.formGroup.get(controlName)
    const input = event.target as HTMLInputElement;
    control?.markAsTouched();
    control?.markAsDirty();
  }
  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
  duplicatePrevision(element?: any): void {
    const dialogRef = this.dialog.open(HoldersWasteForecastDuplicateDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        prevision: element,
        duplicar:true,
        poseedorInfo: this.poseedorInfo,
        previsiones: this.grid
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarPoseedorEvent.emit(true);
      }
    });
  }
  editPrevision(element?: any) {
   const dialogRef = this.dialog.open(HoldersWasteForecastDuplicateDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        prevision: element,
        editar:true,
        poseedorInfo: this.poseedorInfo,
        previsiones: this.grid
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarPoseedorEvent.emit(true);
      }
    });
  }
  buscarPrevision() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    const { backendFilter, page, size } = this.getBackendFilterBuscador();
    this.spinnerSrv.loadingShow();
    this.searchSubscription = this.residuoEnvaseControllerSrv
      .findAll3(backendFilter, { page: page, size: size })
      .subscribe({
        next: (res) => {
          if (res && res.datos && res.datos.length > 0) {
            let observables: any[] = [];

            res.datos.forEach((residuo: any) => {
              let observable = this.residuoEnvaseControllerSrv
                .comprobarNimaGestor(residuo.id)
                .pipe(
                  map((resultado: any) => {
                    residuo.existeNima = resultado;
                    return residuo;
                  }),
                  catchError((error: any) => {
                    console.error(
                      `Error comprobando Nima para residuo con id ${residuo.id}:`,
                      error
                    );
                    residuo.existeNima = false;
                    return of(residuo);
                  })
                );
              observables.push(observable);
            });

            zip(...observables).subscribe((residuosActualizados: any[]) => {
              this.spinnerSrv.loadingHide();
              this.grid = this.canAccessAll(residuosActualizados);
              // Usar setTimeout con detectChanges para asegurar que el DOM de la tabla se ha procesado
              setTimeout(() => {
                this.cdr.detectChanges();
              });
            });
          } else {
            this.spinnerSrv.loadingHide();
            this.grid = [];
            setTimeout(() => {
              this.cdr.detectChanges();
            });
          }
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }
  addPrevisionModal() {
      const dialogRef = this.dialog.open(HoldersWasteForecastDuplicateDialogComponent, {
      width: '950px',
      maxWidth: '95%',
      maxHeight: '95vh',
      disableClose: true,
      data: {
        prevision: undefined,
        nueva: true,
        poseedorInfo: this.poseedorInfo,
        previsiones: this.grid
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.refrescarPoseedorEvent.emit(true);
      }
    });
  }
}
